if(!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();

      this.productVariantsData = JSON.parse(this.querySelector('#product-variants').textContent);
      this.samplersBlock = this.querySelector('.samplers-options__block');
      this.inputs = this.querySelectorAll('.option-input, .special-product-input, .special-product-input-2');
      this.samplerInputs = this.querySelectorAll('.sampler-input');
      this.inputs.forEach((input) => {
        input.addEventListener('change', this.onVariantChange.bind(this));
      })

      //@stayai: all products' selling plan groups keyed by handle { "handle": [groups], ... }
      this.allProductsSellingPlanGroupsData = JSON.parse(this.querySelector('#all-products-selling-plan-groups-data').textContent);

      //@stayai: get selected product's handle from product form attribute
      const productForm = this.closest('.product-main')?.querySelector('product-form.product-form')
        ?? document.querySelector('.product-info product-form.product-form');
      const initialHandle = (productForm?.dataset?.productHandle ?? this.productVariantsData?.[0]?.handle) || null;

      //@stayai: get selected product's selling plan groups from allProductsSellingPlanGroupsData
      this.productSellingPlanGroupsData = this._getSellingPlanGroupsForHandle(initialHandle);

      //@stayai: lookup tables for selling plan id → app id and plan id → name (from current product's groups only)
      const { planIdToAppId, planIdToName } = this.buildPlanIdLookups(this.productSellingPlanGroupsData);
      this.planIdToAppId = planIdToAppId;
      this.planIdToName = planIdToName;
      this.LEGACY_APP_ID = '294517';
      this.STAYAI_APP_ID = '5859381';
      this.ACTIVE_SUBS_APP = 'STAYAI';
      if(this.ACTIVE_SUBS_APP == 'STAYAI') {
        this.ACTIVE_APP_ID = this.STAYAI_APP_ID;
      } else {
        this.ACTIVE_APP_ID = this.LEGACY_APP_ID;
      }
    }

    onVariantChange(e) {
      let selectedOptions;
      let matchingVariant;

      if(e.target.classList.contains('special-product-input')) {
        this.querySelector('.options-block:is(.special-product-option)')?.classList.remove('hidden');
        this.querySelectorAll('.options-block:not(.special-product-option), .samplers-options__block').forEach(el => el.classList.add('hidden'));
        selectedOptions = Array.from(this.querySelectorAll('.special-product-input:checked:not([name="flavor"])'))
          .map(el => el.value);

        const handle = document.querySelector('.special-product-input[data-type="flavor"]:checked').dataset.handle;
        matchingVariant = this.productVariantsData.find(variant =>
          variant.options.every((opt, i) => opt === selectedOptions[i]) && handle === variant.handle
        );

      }
      else if(e.target.classList.contains('special-product-input-2')) {
        this.querySelector('.options-block:is(.special-product-option-2)')?.classList.remove('hidden');
        this.querySelectorAll('.options-block:not(.special-product-option-2), .samplers-options__block').forEach(el => el.classList.add('hidden'));
        selectedOptions = Array.from(this.querySelectorAll('.special-product-input-2:checked:not([name="flavor"])'))
          .map(el => el.value);

        const handle = document.querySelector('.special-product-input-2[data-type="flavor"]:checked').dataset.handle;
        matchingVariant = this.productVariantsData.find(variant =>
          variant.options.every((opt, i) => opt === selectedOptions[i]) && handle === variant.handle
        );
      }
      else if(e.target.value.toLowerCase() == 'sampler' || e.target.name == 'sampler') {
        this.querySelectorAll('.options-block').forEach(el => el.classList.add('hidden'));
        this.samplersBlock && this.samplersBlock.classList.remove('hidden');
        selectedOptions = this.querySelector('.sampler-input:checked').value;
        matchingVariant = this.productVariantsData.find(variant => variant.source_product === selectedOptions);
      }
      else {
        this.samplersBlock && this.samplersBlock.classList.add('hidden');
        this.querySelector('.options-block:is(.special-product-option)')?.classList.add('hidden');
        this.querySelector('.options-block:is(.special-product-option-2)')?.classList.add('hidden');
        this.querySelectorAll('.options-block:not(.special-product-option):not(.special-product-option-2)').forEach(el => el.classList.remove('hidden'));

        if (e.target.name === 'flavor') {
          this.syncDependentOptionsToFlavor(e.target.value);
        }

        selectedOptions = Array.from(this.querySelectorAll('.option-input:checked'))
          .filter(el => !el.classList.contains('sampler-input'))
          .map(el => el.value);
        matchingVariant = this.productVariantsData.find(variant =>
          variant.options.every((opt, i) => opt === selectedOptions[i])
        );

        // Fallback: products in main_products may have different option values (e.g. Fruit Punch only ships in 10 Pack while others are 12 Pack).
        if (!matchingVariant) {
          const optionPositions = { flavor: 0, strength: 1, strengths: 1, 'pack-size': 2, size: 2, color: 2 };
          const changedIndex = optionPositions[e.target.name];
          if (changedIndex !== undefined) {
            const candidates = this.productVariantsData.filter(v => v.options[changedIndex] === e.target.value);
            let bestScore = -1;
            candidates.forEach(v => {
              const score = v.options.reduce((acc, opt, i) => acc + (opt === selectedOptions[i] ? 1 : 0), 0);
              if (score > bestScore) {
                matchingVariant = v;
                bestScore = score;
              }
            });
          }
        }
      }

      //@stayai: set current product's selling plan groups from selected variant's handle, then rebuild planIdToAppId
      const selectedProductHandle = matchingVariant ? matchingVariant.handle : null;
      this.productSellingPlanGroupsData = this._getSellingPlanGroupsForHandle(selectedProductHandle);
      const { planIdToAppId, planIdToName } = this.buildPlanIdLookups(this.productSellingPlanGroupsData);
      this.planIdToAppId = planIdToAppId;
      this.planIdToName = planIdToName;

      if (matchingVariant) {
        const productMain = this.closest('.product-main');
        const submitBtn = productMain?.querySelector('.product-form__submit')
          ?? document.querySelector('.product-form__submit');

        if(submitBtn) {
          //TODO: remove hardcoded text values for submit button
          if(matchingVariant.available === 'false') {
            submitBtn.setAttribute('disabled', '');
            submitBtn.querySelector('.add-to-cart-text').textContent = 'Sold out';
          } else {
            submitBtn.removeAttribute('disabled');
            submitBtn.querySelector('.add-to-cart-text').textContent = 'Add to cart';
          }
        }

        // Fire for price-component and any other listeners; must run even when subscriptions.liquid is absent
        document.dispatchEvent(new CustomEvent('price:changed', {
          detail: {
            price: matchingVariant.otp_price,
            compareAtPrice: matchingVariant.otp_compare_at_price,
            type: 'one-time'
          }
        }));
        if (matchingVariant.selling_plans) {
          document.dispatchEvent(new CustomEvent('price:changed', {
            detail: {
              price: matchingVariant.price,
              compareAtPrice: matchingVariant.compareAtPrice,
              type: 'subscription'
            }
          }));
        }

        this.updateCustomSubscriptionBlock(matchingVariant);

        //Selected option value text
        if(e.target.name == 'sampler') {
          const match = e.target.value.match(/\(([^)]+)\)/);
          this.querySelector('.sampler-selected-value').innerText = match ? match[1] : '';
        }
        else {
          const el = this.querySelector(`.${e.target.name}-selected-value`);

          if (el) {
            el.innerText = e.target.value;
          }
          // this.querySelector(`.${e.target.name}-selected-value`).innerText = e.target.value;
        }

        // Sync Strength / Pack-Size labels to the matched variant's actual options.
        // Needed when the fallback above picks a variant that doesn't share the previously-selected strength or pack size.
        const strengthLabel = this.querySelector('.strength-selected-value, .strengths-selected-value');
        if (strengthLabel && matchingVariant.options[1]) strengthLabel.innerText = matchingVariant.options[1];
        const packSizeLabel = this.querySelector('.pack-size-selected-value, .size-selected-value, .color-selected-value');
        if (packSizeLabel && matchingVariant.options[2]) packSizeLabel.innerText = matchingVariant.options[2];

        // @@@ sync with non-subscription relatied DOM elements > Changing title, image, rating_count, description per variant
        const title = productMain?.querySelector('.product-title') ?? document.querySelector('.product-title');
        const description = this.querySelector('.product-description');
        const ratingCount = productMain?.querySelector('.sr-block__rating-count') ?? document.querySelector('.sr-block__rating-count');
        const featuredImage = productMain ? productMain.querySelectorAll('.featured-image') : document.querySelectorAll('.featured-image');
        const starRatingIcons = productMain?.querySelector('.sr-block__icons') ?? document.querySelector('.sr-block__icons');
        if(title) title.innerText = (matchingVariant.title || title);
        const metafieldImages = matchingVariant.variant_metafield_images;

        if (metafieldImages && metafieldImages.length > 0) {
          const mainSliderImages = document.querySelectorAll('.product-img');
          const thumbnailsImages = document.querySelectorAll('.thumb-img');

          this.updateProductImages(mainSliderImages, metafieldImages)
          this.updateProductImages(thumbnailsImages, metafieldImages)
          this.resetSwipers()
        } else {
          const fallbackImages = matchingVariant.product_images;
          if (fallbackImages && fallbackImages.length > 0) {
            const mainSliderImages = document.querySelectorAll('.product-img');
            const thumbnailsImages = document.querySelectorAll('.thumb-img');
            this.updateProductImages(mainSliderImages, fallbackImages);
            this.updateProductImages(thumbnailsImages, fallbackImages);
          } else {
            if(featuredImage) featuredImage.forEach(image => {image.src = matchingVariant.image; image.srcset = ""});
            document.querySelectorAll('.product-img:not(.featured-image)').forEach(img => {
              const slide = img.closest('.swiper-slide');
              if (slide) slide.style.display = 'none';
            });
            document.querySelectorAll('.thumb-img:not(.featured-image)').forEach(img => {
              const slide = img.closest('.swiper-slide');
              if (slide) slide.style.display = 'none';
            });
          }
          this.resetSwipers();
        }
        if(description) description.innerText = matchingVariant.description;
        if(ratingCount) ratingCount.innerText = matchingVariant.rating_count || 0;
        if(starRatingIcons) this.updateStars(starRatingIcons, +matchingVariant.rating_value);

        //update VariantID for product form
        (productMain?.querySelector('.product-variant-id') ?? document.querySelector('.product-variant-id')).value = matchingVariant.id;

        // @stayai: update ProductID, Handle for product form
        const productForm = productMain?.querySelector('product-form.product-form')
          ?? document.querySelector('.product-info product-form.product-form');
        if (productForm) {
          productForm.dataset.productHandle = matchingVariant.handle;
          const productIdInput = productForm.querySelector('input[name="product-id"]');
          if (productIdInput) productIdInput.value = matchingVariant.product_id;
        }

        // Updating url — only on product pages, not on featured product sections placed on other pages
        if (window.location.pathname.startsWith('/products/')) {
          const newUrl = `/products/${matchingVariant.handle}?variant=${matchingVariant.id}`;
          window.history.replaceState({}, '', newUrl);
        }
      }
    }

    /**
     * Syncs subscriptions.liquid DOM with the selected variant: prices, visibility, dropdown options, selling plan input.
     * @param {Object} matchingVariant - The currently selected variant from productVariantsData
     * @returns {boolean} false if .purchase-options__block is missing, true otherwise
     */
    updateCustomSubscriptionBlock(matchingVariant) {
      const scope = this.closest('.product-main') ?? document;
      const purchaseOptionsBlock = scope.querySelector('.purchase-options__block');

      if (!purchaseOptionsBlock) {
        return false;
      }

      // subscriptions.liquid: OTP/sub inputs and block data-price
      scope.querySelector('#purchase-otp')?.setAttribute('data-price', matchingVariant.otp_price);
      scope.querySelector('#purchase-sub')?.setAttribute('data-price', matchingVariant.price);
      scope.querySelector('#purchase-sub')?.setAttribute('data-compare-at-price', matchingVariant.compareAtPrice);
      const priceForSubOptionCalculation = matchingVariant.selling_plans
        ? +matchingVariant.compareAtPrice.substring(1) * 100
        : +matchingVariant.price.substring(1) * 100;
      purchaseOptionsBlock.setAttribute('data-price', priceForSubOptionCalculation);

      // subscriptions.liquid: show/hide block, dropdown options, #selling-plan-input
      const sellingPlanInput = scope.querySelector('#selling-plan-input');
      if (matchingVariant.selling_plans) {

         // @stayai: filter selling plan allocations by ACTIVE_APP_ID
        const activeVariantSellingPlanAllocations = matchingVariant.selling_plan_allocations.filter(obj => {
          const planId = obj.selling_plan_id;
          const fetchedAppId = this.planIdToAppId.get(Number(planId))
          return planId != null && fetchedAppId === this.ACTIVE_APP_ID;
        });

        // Keep the shopper's chosen plan (#purchase-sub starts on the default plan) if this variant offers it
        const subInput = scope.querySelector('#purchase-sub');
        const selectedPlanId = this.getSelectedPlanId(matchingVariant, subInput?.dataset.sellingPlan);

        const { dropdownOptions, dropdownText } = this.renderSellingPlans(matchingVariant, Shopify.currency.active, selectedPlanId);

        scope.querySelector('.subs-dropdown-options').innerHTML = dropdownOptions;
        scope.querySelector('.subs-dropdown-text').innerHTML = dropdownText;

        subInput.checked = true;
        if (selectedPlanId != null) subInput.dataset.sellingPlan = selectedPlanId;
        purchaseOptionsBlock.classList.remove('hidden');

        if (sellingPlanInput) {
          sellingPlanInput.value = selectedPlanId ?? this.getPlanIdFromAlloc(activeVariantSellingPlanAllocations[0]) ?? '';
        }
      } else {
        if (sellingPlanInput) sellingPlanInput.value = '';
        purchaseOptionsBlock.classList.add('hidden');
      }

      return true;
    }

    // When a flavor is clicked, hide option radios (Pack Size / Size / Color) that don't apply
    // to that flavor's product, and check the first supported one if the current selection becomes hidden.
    syncDependentOptionsToFlavor(flavorValue) {
      const flavorVariants = this.productVariantsData.filter(v => v.options[0] === flavorValue);
      if (!flavorVariants.length) return;
      const productHandle = flavorVariants[0].handle;
      const handleToken = `,${productHandle},`;

      const dependentLabels = this.querySelectorAll('label[data-supports-handles]');
      const affectedBlocks = new Set();

      dependentLabels.forEach(label => {
        const input = label.querySelector('input');
        if (!input || input.name === 'flavor') return;
        const supports = label.dataset.supportsHandles || '';
        const isSupported = supports.includes(handleToken);

        if (isSupported) {
          label.classList.remove('hidden');
        } else {
          label.classList.add('hidden');
          if (input.checked) input.checked = false;
        }
        const fieldset = input.closest('fieldset');
        if (fieldset) affectedBlocks.add(fieldset);
      });

      affectedBlocks.forEach(block => {
        if (block.querySelector('input:checked')) return;
        const firstSupported = block.querySelector('label:not(.hidden) input');
        if (firstSupported) {
          firstSupported.checked = true;
          const valueEl = block.querySelector(`.${firstSupported.name}-selected-value`);
          if (valueEl) valueEl.innerText = firstSupported.value;
        }
      });
    }

    updateProductImages(images, newImages) {
      images.forEach((image, index) => {
        const slide = image.closest('.swiper-slide');
        if (index < newImages.length) {
          image.src = newImages[index];
          image.srcset = '';
          if (slide) slide.style.display = '';
        } else {
          image.src = '';
          image.srcset = '';
          if (slide) slide.style.display = 'none';
        }
      });

      // After a page reload (e.g. Sampler reload), the DOM may have fewer slides than the
      // new product needs. Add the missing slides so Swiper can show all images.
      if (newImages.length > images.length) {
        const isThumb = images.length > 0 && images[0].classList.contains('thumb-img');
        const extra = newImages.slice(images.length);
        extra.forEach(src => isThumb ? this.addThumbSlide(src) : this.addMainSlide(src));
      }
    }

    addMainSlide(src) {
      const productMain = this.closest('.product-main');
      const wrapper = (productMain ?? document).querySelector('.product-main-swiper .swiper-wrapper');
      if (!wrapper) return;
      const slide = document.createElement('div');
      slide.className = 'swiper-slide product-main-slide';
      const img = document.createElement('img');
      img.className = 'product-img';
      img.src = src;
      img.srcset = '';
      slide.appendChild(img);
      wrapper.appendChild(slide);
    }

    addThumbSlide(src) {
      const productMain = this.closest('.product-main');
      const wrapper = (productMain ?? document).querySelector('.product-thumbs-swiper .swiper-wrapper');
      if (!wrapper) return;
      const slide = document.createElement('div');
      slide.className = 'swiper-slide product-thumbs-slide';
      const inner = document.createElement('div');
      inner.className = 'product-thumbs-slide-inner';
      const img = document.createElement('img');
      img.className = 'thumb-img';
      img.src = src;
      img.srcset = '';
      inner.appendChild(img);
      slide.appendChild(inner);
      wrapper.appendChild(slide);
    }

    resetSwipers() {
      requestAnimationFrame(() => {
        const productMain = this.closest('.product-main');
        const thumbsSwiper = productMain?.productThumbsSwiper ?? window.productThumbsSwiper;
        const mainSwiper = productMain?.productMainSwiper ?? window.productMainSwiper;

        if (thumbsSwiper) {
          thumbsSwiper.update();
          thumbsSwiper.slideTo(0, 0);
        }
        if (mainSwiper) {
          mainSwiper.update();
          mainSwiper.slideTo(0, 0);
        }
      });
    }

    // @@@ "subscriptions.liquid" custom_subscription_buybox
    renderSellingPlans(variant, shopCurrency, selectedPlanId = null) {
      if (!variant.selling_plan_groups || !variant.selling_plan_groups.length) return { dropdownOptions: "", dropdownText: "" };

      const stay_prefix_1 = '>>>>>> ';
      // console.log(stay_prefix_1 +  `renderSellingPlans()  selected product handle [ ${variant.handle} ], ACTIVE_APP_ID [ ${this.ACTIVE_APP_ID} ]`);

      //@stayai: only display variant's selling plans where app_id is ACTIVE_APP_ID. Variant JSON has no group.app_id; look up by plan id.
      let activeVariantSellingPlans = variant.selling_plan_groups.filter(group => {
        const planId = group.selling_plans?.[0]?.id;
        const fetchedAppId = this.planIdToAppId.get(Number(planId));
        return planId != null && fetchedAppId === this.ACTIVE_APP_ID;
      });
      if (!activeVariantSellingPlans.length) return { dropdownOptions: "", dropdownText: "" };

      const firstGroup = activeVariantSellingPlans[0];
      const firstPlan = firstGroup.selling_plans.find(plan => String(plan.id) === String(selectedPlanId)) ?? firstGroup.selling_plans[0];

      let firstLabel  = ''
      if(this.ACTIVE_SUBS_APP == 'STAYAI') {
        firstLabel = this.getSellingPlanName(firstPlan.id)
      } else {
        firstLabel = firstGroup.name.split("Subscription")[0].trim().toLowerCase();
      }

      const firstDiscountSuffix = firstPlan.value_type === "percentage" ? "%" : shopCurrency;
      const discountBadge = document.querySelector('.purchase-discount');
      if (discountBadge) discountBadge.innerHTML = `Save up to ${firstPlan.value}${firstDiscountSuffix}`;
      // Render the selected dropdown text
      const dropdownText = `
        <span>${firstLabel}</span>
        <span class="dropdown-option-discount">${firstPlan.value}${firstDiscountSuffix} off</span>
      `;

      const dropdownOptions = this.renderSellingPlanDropdownOptions(activeVariantSellingPlans, this.ACTIVE_SUBS_APP, shopCurrency);

      return { dropdownOptions, dropdownText };
    }

    /**
     * Renders the dropdown option list HTML for subscriptions.liquid (.subs-dropdown-options).
     * @param {Array} sellingPlans - Selling plan groups for the active app
     * @param {string} activeApp - Active subscription app identifier (e.g. 'STAYAI')
     * @param {string} shopCurrency - Shop currency code
     * @returns {string} HTML string of <li class="dropdown-option"> elements
     */
    renderSellingPlanDropdownOptions(sellingPlans, activeApp, shopCurrency) {
      const array = activeApp === 'STAYAI' ? sellingPlans[0].selling_plans : sellingPlans;
      return array.map(group => {
        const plan = activeApp === 'STAYAI' ? group : group.selling_plans[0];
        const label = activeApp === 'STAYAI'
          ? this.getSellingPlanName(plan.id)
          : group.name.split("Subscription")[0].trim().toLowerCase();
        const discountSuffix = plan.value_type === "percentage" ? "%" : shopCurrency;

        return `
          <li
            role="button"
            class="dropdown-option"
            data-selling-plan="${plan.id}"
            data-currency="${shopCurrency}"
            data-adjustment-type="${plan.value_type}"
            data-adjustment-value="${plan.value}"
            data-subscription-app-id="${this.planIdToAppId.get(plan.id)}"
            data-subscription-app-name="${this.getSubsAppName(this.planIdToAppId.get(plan.id))}"
          >
            <span>${label}</span>
            <span class="dropdown-option-discount">
              ${plan.value}${discountSuffix} off
            </span>
          </li>
        `;
      }).join("");
    }

    updateStars(el,rating) {
      const maxStars = 5;
      for (let i = 1; i <= maxStars; i++) {
        let fill = 0;
        let diff = rating - i;
        if (diff >= 0) {
          fill = 100;
        } else if (diff >  -1) {
          fill = Math.round((rating - (i - 1)) * 100);
        } else {
          fill = 0;
        }

        // Update SVG stops
        const fillStop = el.querySelector(`#grad-stop-fill-${i}`);
        const emptyStop = el.querySelector(`#grad-stop-empty-${i}`);
        if (fillStop && emptyStop) {
          fillStop.setAttribute('offset', fill + '%');
          emptyStop.setAttribute('offset', fill + '%');
        }
      }
    }

    // @stayai: plan to select for a variant — the current choice if the variant offers it, else the "2 month" plan, else the first plan
    getSelectedPlanId(variant, currentPlanId) {
      const group = (variant.selling_plan_groups || []).find(g => {
        const planId = g.selling_plans?.[0]?.id;
        return planId != null && this.planIdToAppId.get(Number(planId)) === this.ACTIVE_APP_ID;
      });
      const plans = group?.selling_plans || [];
      if (!plans.length) return null;
      const current = plans.find(plan => String(plan.id) === String(currentPlanId));
      const twoMonth = plans.find(plan => /^2 month/i.test(this.getSellingPlanName(plan.id)));
      return (current ?? twoMonth ?? plans[0]).id;
    }

    // @stayai: get plan id from allocation
    getPlanIdFromAlloc(alloc) {
      if (!alloc) return null;
      const sellingPlan = alloc.selling_plan ?? alloc.selling_plans?.[0];
      const planId = alloc.selling_plan_id ?? sellingPlan?.id;
      return planId;
    }

    // @stayai: get selling plan groups array for a product handle from allProductsSellingPlanGroupsData
    _getSellingPlanGroupsForHandle(handle) {
      const data = this.allProductsSellingPlanGroupsData;
      if (Array.isArray(data)) return data;
      if (!handle) return [];
      return data[handle] ?? [];
    }

    // @stayai: single pass over productSellingPlanGroupsData → planIdToAppId + planIdToName
    buildPlanIdLookups(productSellingPlanGroupsData) {
      const planIdToAppId = new Map();
      const planIdToName = new Map();
      for (let i = 0; i < productSellingPlanGroupsData.length; i++) {
        const g = productSellingPlanGroupsData[i];
        const appId = g.app_id;
        const plans = g.selling_plans || [];
        for (let j = 0; j < plans.length; j++) {
          const plan = plans[j];
          const id = Number(plan.id);
          if (!Number.isFinite(id)) continue;
          if (!planIdToAppId.has(id)) planIdToAppId.set(id, appId);
          if (plan.name != null) planIdToName.set(id, plan.name);
        }
      }
      return { planIdToAppId, planIdToName };
    }
    // @stayai
    getSubsAppName(appId){
      if(appId == '5859381'){
        return 'STAYAI'
      } else{
        return 'LEGACYAPP'
      }
    }
    // @stayai
    getSellingPlanName(sellingPlanId) {
      return this.planIdToName.get(Number(sellingPlanId)) ?? '';
    }
  }

  customElements.define('variant-picker', VariantPicker)
}
